// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pages-ManageTBSyncHotels-styles___h1--TOItJ {
  text-align: left;
}

.pages-ManageTBSyncHotels-styles___paper--vI9pq {
  padding: 64px 40px 32px;
  padding-bottom: 0;
  border-radius: 0;
  box-shadow: none;
  border-top: none;
  border-left: none;
  border-right: none;
}

.pages-ManageTBSyncHotels-styles___body--yY9Lv {
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  height: calc(100vh - 200px);
  overflow: auto;
}

.pages-ManageTBSyncHotels-styles___half--q1jwb {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  min-height: 0;
  min-width: 0;
  height: 100%;
  overflow: auto;
}

.pages-ManageTBSyncHotels-styles___leftHalf--J_gsp {
  padding-right: 24px;
  justify-content: space-between;
}

.pages-ManageTBSyncHotels-styles___leftHalf--J_gsp > .pages-ManageTBSyncHotels-styles___sectionCard--GjmoZ {
  min-height: 0;
  overflow: auto;
}

.pages-ManageTBSyncHotels-styles___leftHalf--J_gsp > .pages-ManageTBSyncHotels-styles___sectionCard--GjmoZ:first-child {
  max-height: 272px;
}

.pages-ManageTBSyncHotels-styles___leftHalf--J_gsp > .pages-ManageTBSyncHotels-styles___sectionCard--GjmoZ:last-child {
  max-height: 252px;
}

.pages-ManageTBSyncHotels-styles___divider--OJbX_ {
  margin: 0;
}

.pages-ManageTBSyncHotels-styles___inputs--JDgI6 {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 16px;
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___input--jkKtE {
  flex: 1;
}

.pages-ManageTBSyncHotels-styles___input--jkKtE .MuiFormHelperText-root {
    font-size: 11px;
    line-height: 1.2;
    margin: 4px 8px 0;
    white-space: nowrap;
  }

.pages-ManageTBSyncHotels-styles___or--D25N_ {
  align-self: flex-start;
  color: #516074;
  font-size: 14px;
  font-weight: 600;
  line-height: 40px;
  margin-top: 8px;
  text-transform: uppercase;
}

.MuiInputBase-root {
    background-color: white;
  }

.pages-ManageTBSyncHotels-styles___button--sqFV6 {
  white-space: nowrap;
  flex-shrink: 0;
}

.pages-ManageTBSyncHotels-styles___actions--BdbGq {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___actionError--iLeg7 {
  flex: 1;
  min-width: 0;
  overflow: auto;
  align-items: flex-start;
  padding: 12px;
}

.pages-ManageTBSyncHotels-styles___actionError--iLeg7 .MuiAlert-icon {
    align-items: flex-start;
  }

.pages-ManageTBSyncHotels-styles___actionError--iLeg7 .MuiAlert-message {
    text-align: left;
    overflow: auto;
  }

.pages-ManageTBSyncHotels-styles___info--ef_HV {
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___info--ef_HV .MuiAlert-icon {
    align-items: center;
  }

.pages-ManageTBSyncHotels-styles___info--ef_HV .MuiAlert-message {
    text-align: left;
    font-size: 14px;
  }

.pages-ManageTBSyncHotels-styles___singleInputRow--Tn2k4 {
  display: block;
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___lookupForm--p4tpN {
  width: 100%;
  padding-top: 24px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.pages-ManageTBSyncHotels-styles___sectionCard--GjmoZ {
  width: 100%;
  padding: 12px;
  border: 1px solid #d8dde6;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 12px;
  min-width: 0;
}

.pages-ManageTBSyncHotels-styles___formSubtitle--HX9Dd {
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  color: #1b2432;
  font-size: 20px;
  font-weight: 600;
  text-align: left;
  padding-bottom: 8px;
  border-bottom: 1px solid #e7ebf0;
}

.pages-ManageTBSyncHotels-styles___lookupInput--ZLhsn {
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___lookupActions--H5b6T {
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 12px;
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___lookupActionError--NTkKf {
  flex: 1;
  min-width: 0;
  overflow: auto;
  align-items: flex-start;
  padding: 12px;
}

.pages-ManageTBSyncHotels-styles___lookupActionError--NTkKf .MuiAlert-icon {
    align-items: flex-start;
  }

.pages-ManageTBSyncHotels-styles___lookupActionError--NTkKf .MuiAlert-message {
    text-align: left;
    overflow: auto;
  }

.pages-ManageTBSyncHotels-styles___error--Plgpe {
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___rightHalf--ZUm2c {
  padding-left: 24px;
  overflow: hidden;
  height: 100%;
}

.pages-ManageTBSyncHotels-styles___resultsSubtitle--ACRoy {
  margin: 0;
  width: 100%;
  box-sizing: border-box;
  color: #1b2432;
  font-size: 22px;
  font-weight: 700;
  text-align: left;
  padding-bottom: 12px;
  border-bottom: 1px solid #e7ebf0;
}

.pages-ManageTBSyncHotels-styles___rightHalf--ZUm2c .pages-ManageTBSyncHotels-styles___resultSection--xCzew {
  margin-left: 0;
}

.pages-ManageTBSyncHotels-styles___resultsShell--PTMch {
  width: 100%;
  max-width: 552px;
  height: 100%;
  padding: 12px;
  border: 1px solid #d8dde6;
  border-radius: 10px;
  background-color: #fff;
  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  gap: 16px;
  flex: 1;
  min-height: 0;
  min-width: 0;
  overflow: hidden;
}

.pages-ManageTBSyncHotels-styles___resultSection--xCzew {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex: 1;
  min-height: 0;
  min-width: 0;
}

.pages-ManageTBSyncHotels-styles___sectionHeader--Qo6O3 {
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.pages-ManageTBSyncHotels-styles___sectionTitle--MJ7rF {
  margin: 0;
  color: #1b2432;
  font-size: 16px;
  font-weight: 600;
}

.pages-ManageTBSyncHotels-styles___copyButton--g9gbQ {
  color: #516074;
  cursor: pointer;
}

.pages-ManageTBSyncHotels-styles___copyButton--g9gbQ:hover {
    color: #1b2432;
    background-color: #e9eef5;
  }

.pages-ManageTBSyncHotels-styles___copyButton--g9gbQ:disabled {
    cursor: default;
  }

.pages-ManageTBSyncHotels-styles___scrollSquare--JrQcI {
  width: 100%;
  min-width: 0;
  min-height: 0;
  height: 100%;
  overflow: auto;
  border: 1px solid #d5dce5;
  border-radius: 8px;
  background-color: #f7f9fc;
  padding: 12px;
  text-align: left;
  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.04);
}

.pages-ManageTBSyncHotels-styles___jsonBlock--yQQe7 {
  margin: 0;
  font-size: 12px;
  line-height: 1.6;
  white-space: pre;
  color: #243143;
  text-align: left;
}

.pages-ManageTBSyncHotels-styles___jsonCode--s4H9k {
  display: block;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;
}

.pages-ManageTBSyncHotels-styles___jsonBlock--yQQe7 .jsonKey {
  color: #0550ae;
  font-weight: 600;
}

.pages-ManageTBSyncHotels-styles___jsonBlock--yQQe7 .jsonString {
  color: #0a7a45;
}

.pages-ManageTBSyncHotels-styles___jsonBlock--yQQe7 .jsonNumber {
  color: #6f42c1;
}

.pages-ManageTBSyncHotels-styles___jsonBlock--yQQe7 .jsonBoolean {
  color: #b42318;
  font-weight: 600;
}

.pages-ManageTBSyncHotels-styles___jsonBlock--yQQe7 .jsonNull {
  color: #6e7781;
  font-style: italic;
}

.pages-ManageTBSyncHotels-styles___placeholder--S5vL1 {
  color: #516074;
  font-size: 14px;
}

.pages-ManageTBSyncHotels-styles___hotelEntries--XLRAV {
  display: flex;
  flex-direction: column;
  gap: 12px;
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___hotelEntry--qBhhN {
  display: flex;
  flex-direction: column;
  gap: 4px;
  width: 100%;
  border-bottom: 1px solid #e7ebf0;
  padding-bottom: 12px;
}

.pages-ManageTBSyncHotels-styles___hotelEntry--qBhhN:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.pages-ManageTBSyncHotels-styles___hotelEntryTitle--alX32 {
  color: #0a7a45;
  font-size: 14px;
  font-weight: 600;
  white-space: nowrap;
}

.pages-ManageTBSyncHotels-styles___hotelEntryHeader--NqBqa {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 8px;
  width: 100%;
}

.pages-ManageTBSyncHotels-styles___hotelEntryPreview--nUPdL {
  flex: 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  color: #243143;
  font-size: 14px;
  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;
}

.pages-ManageTBSyncHotels-styles___hotelEntryPreview--nUPdL .jsonKey {
  color: #0550ae;
  font-weight: 600;
}

.pages-ManageTBSyncHotels-styles___hotelEntryPreview--nUPdL .jsonString {
  color: #0a7a45;
}

.pages-ManageTBSyncHotels-styles___hotelEntryPreview--nUPdL .jsonNumber {
  color: #6f42c1;
}

.pages-ManageTBSyncHotels-styles___hotelEntryPreview--nUPdL .jsonBoolean {
  color: #b42318;
  font-weight: 600;
}

.pages-ManageTBSyncHotels-styles___hotelEntryPreview--nUPdL .jsonNull {
  color: #6e7781;
  font-style: italic;
}

.pages-ManageTBSyncHotels-styles___expandButton--m2z0n {
  color: #516074;
  transition: transform 0.15s ease-in-out;
}

.pages-ManageTBSyncHotels-styles___expandButton--m2z0n:hover {
    color: #1b2432;
    background-color: #e9eef5;
  }

.pages-ManageTBSyncHotels-styles___expandButtonOpen--cubOl {
  transform: rotate(180deg);
}

.pages-ManageTBSyncHotels-styles___header--sRp3A {
  text-align: left;
  padding-top: 30px;
}

.pages-ManageTBSyncHotels-styles___header--sRp3A h1 {
    margin: 0;
    font-family: 'Roboto';
    font-size: 40px;
    color: #1b2432;
    letter-spacing: 0;
  }
`, "",{"version":3,"sources":["webpack://./pages/ManageTBSyncHotels/styles.pcss"],"names":[],"mappings":"AAAA;EACE,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,cAAc;AAChB;;AAEA;EACE,OAAO;EACP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,YAAY;EACZ,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,iBAAiB;AACnB;;AAGA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;AAQT;;AANE;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,mBAAmB;EACrB;;AAGF;EACE,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,yBAAyB;AAC3B;;AAEE;IACE,uBAAuB;EACzB;;AAEF;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,aAAa;AAUf;;AARE;IACE,uBAAuB;EACzB;;AAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;AAGF;EACE,WAAW;AAUb;;AARE;IACE,mBAAmB;EACrB;;AAEA;IACE,gBAAgB;IAChB,eAAe;EACjB;;AAGF;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,gCAAgC;AAClC;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,cAAc;EACd,uBAAuB;EACvB,aAAa;AAUf;;AARE;IACE,uBAAuB;EACzB;;AAEA;IACE,gBAAgB;IAChB,cAAc;EAChB;;AAGF;EACE,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,WAAW;EACX,sBAAsB;EACtB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,oBAAoB;EACpB,gCAAgC;AAClC;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,sBAAsB;EACtB,4CAA4C;EAC5C,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,OAAO;EACP,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,OAAO;EACP,aAAa;EACb,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,SAAS;EACT,cAAc;EACd,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,eAAe;AAUjB;;AARE;IACE,cAAc;IACd,yBAAyB;EAC3B;;AAEA;IACE,eAAe;EACjB;;AAGF;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,YAAY;EACZ,cAAc;EACd,yBAAyB;EACzB,kBAAkB;EAClB,yBAAyB;EACzB,aAAa;EACb,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,WAAW;EACX,gCAAgC;EAChC,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,WAAW;AACb;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,4EAA4E;AAC9E;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,uCAAuC;AAMzC;;AAJE;IACE,cAAc;IACd,yBAAyB;EAC3B;;AAGF;EACE,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AASnB;;AAPE;IACE,SAAS;IACT,qBAAqB;IACrB,eAAe;IACf,cAAc;IACd,iBAAiB;EACnB","sourcesContent":[".h1 {\n  text-align: left;\n}\n\n.paper {\n  padding: 64px 40px 32px;\n  padding-bottom: 0;\n  border-radius: 0;\n  box-shadow: none;\n  border-top: none;\n  border-left: none;\n  border-right: none;\n}\n\n.body {\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: row;\n  height: calc(100vh - 200px);\n  overflow: auto;\n}\n\n.half {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 24px;\n  min-height: 0;\n  min-width: 0;\n  height: 100%;\n  overflow: auto;\n}\n\n.leftHalf {\n  padding-right: 24px;\n  justify-content: space-between;\n}\n\n.leftHalf > .sectionCard {\n  min-height: 0;\n  overflow: auto;\n}\n\n.leftHalf > .sectionCard:first-child {\n  max-height: 272px;\n}\n\n.leftHalf > .sectionCard:last-child {\n  max-height: 252px;\n}\n\n\n.divider {\n  margin: 0;\n}\n\n.inputs {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 16px;\n  width: 100%;\n}\n\n.input {\n  flex: 1;\n\n  :global(.MuiFormHelperText-root) {\n    font-size: 11px;\n    line-height: 1.2;\n    margin: 4px 8px 0;\n    white-space: nowrap;\n  }\n}\n\n.or {\n  align-self: flex-start;\n  color: #516074;\n  font-size: 14px;\n  font-weight: 600;\n  line-height: 40px;\n  margin-top: 8px;\n  text-transform: uppercase;\n}\n\n  :global(.MuiInputBase-root) {\n    background-color: white;\n  }\n\n.button {\n  white-space: nowrap;\n  flex-shrink: 0;\n}\n\n.actions {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n}\n\n.actionError {\n  flex: 1;\n  min-width: 0;\n  overflow: auto;\n  align-items: flex-start;\n  padding: 12px;\n\n  :global(.MuiAlert-icon) {\n    align-items: flex-start;\n  }\n\n  :global(.MuiAlert-message) {\n    text-align: left;\n    overflow: auto;\n  }\n}\n\n.info {\n  width: 100%;\n\n  :global(.MuiAlert-icon) {\n    align-items: center;\n  }\n\n  :global(.MuiAlert-message) {\n    text-align: left;\n    font-size: 14px;\n  }\n}\n\n.singleInputRow {\n  display: block;\n  width: 100%;\n}\n\n.lookupForm {\n  width: 100%;\n  padding-top: 24px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.sectionCard {\n  width: 100%;\n  padding: 12px;\n  border: 1px solid #d8dde6;\n  border-radius: 10px;\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  min-width: 0;\n}\n\n.formSubtitle {\n  margin: 0;\n  width: 100%;\n  box-sizing: border-box;\n  color: #1b2432;\n  font-size: 20px;\n  font-weight: 600;\n  text-align: left;\n  padding-bottom: 8px;\n  border-bottom: 1px solid #e7ebf0;\n}\n\n.lookupInput {\n  width: 100%;\n}\n\n.lookupActions {\n  display: flex;\n  flex-direction: row;\n  align-items: flex-start;\n  gap: 12px;\n  width: 100%;\n}\n\n.lookupActionError {\n  flex: 1;\n  min-width: 0;\n  overflow: auto;\n  align-items: flex-start;\n  padding: 12px;\n\n  :global(.MuiAlert-icon) {\n    align-items: flex-start;\n  }\n\n  :global(.MuiAlert-message) {\n    text-align: left;\n    overflow: auto;\n  }\n}\n\n.error {\n  width: 100%;\n}\n\n.rightHalf {\n  padding-left: 24px;\n  overflow: hidden;\n  height: 100%;\n}\n\n.resultsSubtitle {\n  margin: 0;\n  width: 100%;\n  box-sizing: border-box;\n  color: #1b2432;\n  font-size: 22px;\n  font-weight: 700;\n  text-align: left;\n  padding-bottom: 12px;\n  border-bottom: 1px solid #e7ebf0;\n}\n\n.rightHalf .resultSection {\n  margin-left: 0;\n}\n\n.resultsShell {\n  width: 100%;\n  max-width: 552px;\n  height: 100%;\n  padding: 12px;\n  border: 1px solid #d8dde6;\n  border-radius: 10px;\n  background-color: #fff;\n  box-shadow: 0 1px 3px rgba(16, 24, 40, 0.06);\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n  overflow: hidden;\n}\n\n.resultSection {\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  flex: 1;\n  min-height: 0;\n  min-width: 0;\n}\n\n.sectionHeader {\n  width: 100%;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.sectionTitle {\n  margin: 0;\n  color: #1b2432;\n  font-size: 16px;\n  font-weight: 600;\n}\n\n.copyButton {\n  color: #516074;\n  cursor: pointer;\n\n  &:hover {\n    color: #1b2432;\n    background-color: #e9eef5;\n  }\n\n  &:disabled {\n    cursor: default;\n  }\n}\n\n.scrollSquare {\n  width: 100%;\n  min-width: 0;\n  min-height: 0;\n  height: 100%;\n  overflow: auto;\n  border: 1px solid #d5dce5;\n  border-radius: 8px;\n  background-color: #f7f9fc;\n  padding: 12px;\n  text-align: left;\n  box-shadow: inset 0 1px 2px rgba(16, 24, 40, 0.04);\n}\n\n.jsonBlock {\n  margin: 0;\n  font-size: 12px;\n  line-height: 1.6;\n  white-space: pre;\n  color: #243143;\n  text-align: left;\n}\n\n.jsonCode {\n  display: block;\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;\n}\n\n.jsonBlock :global(.jsonKey) {\n  color: #0550ae;\n  font-weight: 600;\n}\n\n.jsonBlock :global(.jsonString) {\n  color: #0a7a45;\n}\n\n.jsonBlock :global(.jsonNumber) {\n  color: #6f42c1;\n}\n\n.jsonBlock :global(.jsonBoolean) {\n  color: #b42318;\n  font-weight: 600;\n}\n\n.jsonBlock :global(.jsonNull) {\n  color: #6e7781;\n  font-style: italic;\n}\n\n.placeholder {\n  color: #516074;\n  font-size: 14px;\n}\n\n.hotelEntries {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n  width: 100%;\n}\n\n.hotelEntry {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n  width: 100%;\n  border-bottom: 1px solid #e7ebf0;\n  padding-bottom: 12px;\n}\n\n.hotelEntry:last-child {\n  border-bottom: none;\n  padding-bottom: 0;\n}\n\n.hotelEntryTitle {\n  color: #0a7a45;\n  font-size: 14px;\n  font-weight: 600;\n  white-space: nowrap;\n}\n\n.hotelEntryHeader {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 8px;\n  width: 100%;\n}\n\n.hotelEntryPreview {\n  flex: 1;\n  min-width: 0;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  color: #243143;\n  font-size: 14px;\n  font-family: 'SFMono-Regular', Menlo, Consolas, 'Liberation Mono', monospace;\n}\n\n.hotelEntryPreview :global(.jsonKey) {\n  color: #0550ae;\n  font-weight: 600;\n}\n\n.hotelEntryPreview :global(.jsonString) {\n  color: #0a7a45;\n}\n\n.hotelEntryPreview :global(.jsonNumber) {\n  color: #6f42c1;\n}\n\n.hotelEntryPreview :global(.jsonBoolean) {\n  color: #b42318;\n  font-weight: 600;\n}\n\n.hotelEntryPreview :global(.jsonNull) {\n  color: #6e7781;\n  font-style: italic;\n}\n\n.expandButton {\n  color: #516074;\n  transition: transform 0.15s ease-in-out;\n\n  &:hover {\n    color: #1b2432;\n    background-color: #e9eef5;\n  }\n}\n\n.expandButtonOpen {\n  transform: rotate(180deg);\n}\n\n.header {\n  text-align: left;\n  padding-top: 30px;\n\n  h1 {\n    margin: 0;\n    font-family: 'Roboto';\n    font-size: 40px;\n    color: #1b2432;\n    letter-spacing: 0;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"h1": `pages-ManageTBSyncHotels-styles___h1--TOItJ`,
	"paper": `pages-ManageTBSyncHotels-styles___paper--vI9pq`,
	"body": `pages-ManageTBSyncHotels-styles___body--yY9Lv`,
	"half": `pages-ManageTBSyncHotels-styles___half--q1jwb`,
	"leftHalf": `pages-ManageTBSyncHotels-styles___leftHalf--J_gsp`,
	"sectionCard": `pages-ManageTBSyncHotels-styles___sectionCard--GjmoZ`,
	"divider": `pages-ManageTBSyncHotels-styles___divider--OJbX_`,
	"inputs": `pages-ManageTBSyncHotels-styles___inputs--JDgI6`,
	"input": `pages-ManageTBSyncHotels-styles___input--jkKtE`,
	"or": `pages-ManageTBSyncHotels-styles___or--D25N_`,
	"button": `pages-ManageTBSyncHotels-styles___button--sqFV6`,
	"actions": `pages-ManageTBSyncHotels-styles___actions--BdbGq`,
	"actionError": `pages-ManageTBSyncHotels-styles___actionError--iLeg7`,
	"info": `pages-ManageTBSyncHotels-styles___info--ef_HV`,
	"singleInputRow": `pages-ManageTBSyncHotels-styles___singleInputRow--Tn2k4`,
	"lookupForm": `pages-ManageTBSyncHotels-styles___lookupForm--p4tpN`,
	"formSubtitle": `pages-ManageTBSyncHotels-styles___formSubtitle--HX9Dd`,
	"lookupInput": `pages-ManageTBSyncHotels-styles___lookupInput--ZLhsn`,
	"lookupActions": `pages-ManageTBSyncHotels-styles___lookupActions--H5b6T`,
	"lookupActionError": `pages-ManageTBSyncHotels-styles___lookupActionError--NTkKf`,
	"error": `pages-ManageTBSyncHotels-styles___error--Plgpe`,
	"rightHalf": `pages-ManageTBSyncHotels-styles___rightHalf--ZUm2c`,
	"resultsSubtitle": `pages-ManageTBSyncHotels-styles___resultsSubtitle--ACRoy`,
	"resultSection": `pages-ManageTBSyncHotels-styles___resultSection--xCzew`,
	"resultsShell": `pages-ManageTBSyncHotels-styles___resultsShell--PTMch`,
	"sectionHeader": `pages-ManageTBSyncHotels-styles___sectionHeader--Qo6O3`,
	"sectionTitle": `pages-ManageTBSyncHotels-styles___sectionTitle--MJ7rF`,
	"copyButton": `pages-ManageTBSyncHotels-styles___copyButton--g9gbQ`,
	"scrollSquare": `pages-ManageTBSyncHotels-styles___scrollSquare--JrQcI`,
	"jsonBlock": `pages-ManageTBSyncHotels-styles___jsonBlock--yQQe7`,
	"jsonCode": `pages-ManageTBSyncHotels-styles___jsonCode--s4H9k`,
	"placeholder": `pages-ManageTBSyncHotels-styles___placeholder--S5vL1`,
	"hotelEntries": `pages-ManageTBSyncHotels-styles___hotelEntries--XLRAV`,
	"hotelEntry": `pages-ManageTBSyncHotels-styles___hotelEntry--qBhhN`,
	"hotelEntryTitle": `pages-ManageTBSyncHotels-styles___hotelEntryTitle--alX32`,
	"hotelEntryHeader": `pages-ManageTBSyncHotels-styles___hotelEntryHeader--NqBqa`,
	"hotelEntryPreview": `pages-ManageTBSyncHotels-styles___hotelEntryPreview--nUPdL`,
	"expandButton": `pages-ManageTBSyncHotels-styles___expandButton--m2z0n`,
	"expandButtonOpen": `pages-ManageTBSyncHotels-styles___expandButtonOpen--cubOl`,
	"header": `pages-ManageTBSyncHotels-styles___header--sRp3A`
};
module.exports = ___CSS_LOADER_EXPORT___;
